// extracted by mini-css-extract-plugin
export var chevronIcon = "_bn-2";
export var teamName = "_bn-1";
export var teamSwitcherButton = "_bn-0";